import { NOTIFICATION_AREA_CODES, type NotificationAreaCode } from "@/constants/api.notifications";
import { notificationAreaHasDedicatedPage } from "@/features/notifications/lib/notificationDedicatedPages";
import type { AppNotification, NotificationSectionUnreadCounts } from "@/features/notifications/types";

const ENTITY_TYPE_TO_AREA: Record<string, NotificationAreaCode> = {
  room_reservation: "salle",
  service_reservation: "services",
  appointment: "list",
  parcel: "colis",
  cart_order: "cart",
  cart_bar_order: "cartBar",
  ticket: "ticketing",
  message: "messaging",
};

export function emptySectionUnreadCounts(): NotificationSectionUnreadCounts {
  return NOTIFICATION_AREA_CODES.reduce<NotificationSectionUnreadCounts>((acc, code) => {
    acc[code] = 0;
    return acc;
  }, {} as NotificationSectionUnreadCounts);
}

export function normalizeSectionUnreadCounts(
  counts: Partial<Record<NotificationAreaCode, number>> | undefined,
): NotificationSectionUnreadCounts {
  return NOTIFICATION_AREA_CODES.reduce<NotificationSectionUnreadCounts>((acc, code) => {
    const value = counts?.[code];
    acc[code] = typeof value === "number" && Number.isFinite(value) ? Math.max(0, value) : 0;
    return acc;
  }, {} as NotificationSectionUnreadCounts);
}

export const SIDEBAR_PATH_TO_NOTIFICATION_SECTION: Record<string, NotificationAreaCode> = {
  "/appointments": "list",
  "/meetings": "salle",
  "/concierge": "cart",
  "/services": "services",
  "/bar": "cartBar",
  "/messagerie": "messaging",
  "/ticketing/report": "ticketing",
};

export function resolveNotificationSectionForPath(
  path: string,
): NotificationAreaCode | undefined {
  let section: NotificationAreaCode | undefined;
  if (path.startsWith("/ticketing")) {
    section = "ticketing";
  } else {
    section = SIDEBAR_PATH_TO_NOTIFICATION_SECTION[path];
  }
  return notificationAreaHasDedicatedPage(section) ? section : undefined;
}

export const DEFAULT_SECTION_COUNTS = emptySectionUnreadCounts();

export function notificationMatchesSection(
  notification: AppNotification,
  section: NotificationAreaCode,
): boolean {
  const entity = notification.entity_type?.trim();
  if (entity && ENTITY_TYPE_TO_AREA[entity] === section) {
    return true;
  }
  return notification.event_type?.startsWith(`${section}.`) ?? false;
}
